import { BlurEvent, Snackbar, Textbox } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutZipZone } from "./autogen/AutogenLayoutZipZone";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class ZipZone extends AutogenLayoutZipZone {

    override async onLoad(): Promise<void> {
        this.validateZipZoneRecordExist();
        const isEmptyDispatchOverride = getDispatchControlBoolean("enable_empty_dist_override");
        this.textboxEmptyDistanceOverride.visible = isEmptyDispatchOverride;
        this.textboxZone.width = isEmptyDispatchOverride ? 360 : 600;
    }

    private validateZipZoneRecordExist() {
        const zipZoneUrl = "lme/dispatch/ZipZone?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "zipzone", altFieldNameForDupCheck: "zipcode", screenName: "ZipZone", navigateToUrl: zipZoneUrl };
        DuplicateId.configureIdTextbox(this.textboxZipCodeThreeDigit, validateProps);
    }

    textboxEmptyDistanceOverrideOnBlur(event: BlurEvent) {
        const textbox = event.target as Textbox;
        const emptyDistanceOverride = textbox.text;
        if(StringUtil.isEmptyString(emptyDistanceOverride)) {
            return;
        }
        const distanceOverride = parseInt(emptyDistanceOverride);
        if(isNaN(distanceOverride)) {
            Snackbar.showWarningSnackbar("Distance Override must be a valid number");
            this.activeRow.set({ empty_distance_override: null });
            textbox.focus();
            return;
        }
        if (distanceOverride < 0 || distanceOverride > 3500) {
            Snackbar.showWarningSnackbar("Distance Override must be between 0 and 3500");
            this.activeRow.set({ empty_distance_override: null });
            textbox.focus();
            return;
        }
    }

}
